import * as React from 'react';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: number;
}

const NbNewPayouts = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to="/payouts"
            icon={ShoppingCartIcon}
            title={translate('pos.dashboard.new_payout_orders')}
            subtitle={value}
        />
    );
};

export default NbNewPayouts;
